// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"AvatarImage_imageContainer__K2ao3","initialContainer":"AvatarImage_initialContainer__2J_A_"};